/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Telemedicine_Landing_BtnInputs */

const en_service_telemedicine_landing_btn = /** @type {(inputs: Service_Telemedicine_Landing_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn About Telemedicine`)
};

const fr_service_telemedicine_landing_btn = /** @type {(inputs: Service_Telemedicine_Landing_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En savoir plus sur la télémédecine`)
};

/**
* | output |
* | --- |
* | "Learn About Telemedicine" |
*
* @param {Service_Telemedicine_Landing_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_telemedicine_landing_btn = /** @type {((inputs?: Service_Telemedicine_Landing_BtnInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Telemedicine_Landing_BtnInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_telemedicine_landing_btn(inputs)
	return fr_service_telemedicine_landing_btn(inputs)
});